import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE, noop, USER_CONFIG_STORAGE_KEY, VALIDATIONS } from '@client/shared/constants';
import Service from '../service';
import { debounce, getUserData, validate as validator } from '@client/utils';
// import { Alert } from "@client/shared/components";
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import style from '../style';
import { PhoneNumberInput } from "@client/shared/components";

let timeout = null;
let isPhoneInputFocused = false;
const CALL_FAILURE_STATUS = [
    "Error",
    'Invalid',
    "Busy",
    "NoAnswer",
    "Rejected",
    "GenericError",
    "InternationalDisabled",
    "DestinationBlocked",
    "NotEnoughFunds",
    "NoSuchUser"
  ];
  const defaultState = {
    ringoutId: null,
    callInitiatedTime: null,
    recievingVoicemail: false,
    phoneNumber: null,
    phoneNumberError: null,
    isPhoneNumberParsed: false,
    isParsingPhoneNumber: false,
  };

const CallToRecord = ({
    extensionId = null,
    countryList = [],
    handleClose = noop
  }) => {
    const [state, setState] = useState(defaultState);
  
    const makeRingoutCall = async (from) => {
      if (!from) {
        return false;
      }
      const { data } = await Service.getTimestamp();
      const callInitiatedTime = data?.currentTimestamp || new Date().toISOString();
      const response = await Service.makeRingoutCall(from);
      if (response?.error) {
        toast.error(Array.isArray(response.error) ? response.error[0].message : response.error);
      }
      if (response?.data?.id) {
        setState(prevState => ({
          ...prevState,
          ringoutId: response?.data?.id,
          callInitiatedTime,
        }));
      }
      // handleChange({ name: "callToRecordVoicemail", value: null }, "custome");
    };
  
    const postCallHandler = async (success = false, callInitiatedTime, deleteVoicemail = false) => {
      if (success) {
        setState(prevState => ({
          ...prevState,
          recievingVoicemail: true,
        }));

        const { data, error } = await Service.uploadVoicemail({
          dateFrom: callInitiatedTime,
          customerExtensionId: extensionId,
        });
        if (error) {
          toast.error(Array.isArray(error) ? error[0].message : error);
        } else {
          toast.success("Recorded Greeting Media Applied Successfully.");
          handleClose(true);
          // handleChange({ name: "callToRecordVoicemail", value: data?.voicemail || {} }, "custome");
        }
        setState(prevState => ({
          ...prevState,
          recievingVoicemail: false,
          ringoutId: null,
          callInitiatedTime: null,
        }));
      } else {
        console.log("CALL_FAILED");
      }
    };
  
    const getRingoutCallStatus = async (callBack = noop) => {
      clearTimeout(timeout);
      const response = await Service.getRingoutCallStatus(state.ringoutId);
      if (response?.error) {
        toast.error(Array.isArray(response.error) ? response.error[0].message : response.error);
      }
      const { status = {}} = response?.data;
      const isCallFinished = status?.callStatus === 'Success' && status?.callerStatus === 'Finished';
      const isCallFailedOrNoAnswer = status?.callStatus === 'CannotReach' && (status?.callerStatus === 'Busy' || status?.callerStatus === 'NoAnswer');
      const isCallFailed = CALL_FAILURE_STATUS.includes(status?.callStatus);
      if (isCallFinished || isCallFailedOrNoAnswer || !state.ringoutId || isCallFailed) {
        clearTimeout(timeout);
        setState(prevState => {
          callBack(isCallFinished, prevState.callInitiatedTime);
          return {
            ...prevState, 
            ringoutId: null,
            callInitiatedTime: null,
          }
        });
        if (isCallFailed) {
          toast.error(`Call failed. [${status?.callStatus}]`);
        }
      } else {
        timeout = setTimeout(() => getRingoutCallStatus(callBack), 3 * 1000);
      }
    };
  
    const parsePhoneNumber = async () => {
      setState(prevState => ({
        ...prevState,
        isParsingPhoneNumber: true,
      }));
      const { data, error } = await Service.parsePhoneNumber({
        originalStrings: [state.phoneNumber],
      });
      if (error) {
        toast.error(
          Array.isArray(error)
            ? (error[0] && error[0].message) || DEFAULT_ERROR_MESSAGE
            : error
        );
      }
      const phoneNumbers = data && data.phoneNumbers.map(item => item.e164);
      setState(prevState => ({
        ...prevState,
        isParsingPhoneNumber: false,
        isPhoneNumberParsed: true,
        phoneNumber: phoneNumbers && phoneNumbers[0]
      }));
    };
  
    useEffect(() => {
      if (state.ringoutId) {
        getRingoutCallStatus(postCallHandler);
      } else {
        clearTimeout(timeout)
      }
      return () => clearTimeout(timeout);
    }, [state.ringoutId]);
  
    const cancelCall = () => {
      state.ringoutId && Service.cancelRingout(state.ringoutId);
      setState(prevState => ({
        ...prevState,
        ringoutId: null,
        callInitiatedTime: null,
      }));
    };
    
    useEffect(() => {
    if (!((state.phoneNumber || "").length < 3 || !!state.phoneNumberError)) {
        parsePhoneNumber();
    }
    }, []);
		useEffect(() => {
			return () => {
				isPhoneInputFocused = false;
			}
		}, []);
		const isPhoneInputDisabled = !!(state.isParsingPhoneNumber || state.ringoutId || state.recievingVoicemail);

		return (
			<Box sx={{ mt: 4 }}>
      <Typography variant="body2" sx={{ mb: 4, fontWeight: 'bold' }}>
        Call to Record
      </Typography>
      <Box sx={{ mt: 2}}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Box
            sx={{
              mr: 1,
							width: '100%',
              ...(isPhoneInputDisabled ? {
                  pointerEvents: 'none',
                  '& *': {
                    color: 'grey.400' 
                  }
                } : {})
            }}
          >
            <PhoneNumberInput
              classes={{
                list: {
                  '& .MuiMenu-paper': {
                    maxHeight: 400,
                    maxWidth: 400,
                  },
                },
                menu:{
                   maxHeight: 320, maxWidth: 220,
                }
              }}
              isLoading={state.isParsingPhoneNumber}
              disabled={isPhoneInputDisabled}
              value={state.phoneNumber}
              options={countryList}
							onChange={(phoneNumber, phoneNumberError) => {
								const validateResult = validator(phoneNumber, VALIDATIONS.PHONE, countryList);
								const errorMessage = validateResult?.errorMessage ? validateResult.errorMessage : "";
								setState(prevState => ({
									...prevState,
									phoneNumberError: phoneNumberError || errorMessage,
									isPhoneNumberParsed: false,
                  phoneNumber 
								}));
							}}
              onFocus={() => {
                isPhoneInputFocused = true;
              }}
              validations={{
                [VALIDATIONS.REQUIRED]: true,
                [VALIDATIONS.MIN_LENGTH]: 3,
              }}
              error={isPhoneInputFocused ? (state.phoneNumberError || ' ') : ' '}
              onBlur={() => {
                if ((state.phoneNumber || "").length < 3 || !!state.phoneNumberError) {
                  return;
                }
                parsePhoneNumber();
              }}
            />
          </Box>
        </Box>
        <Alert sx={{ my: 1 }} severity="warning">
          Note: Recording will be set as greeting as soon as the call ends. Call to record feature will not work on softphones. It will work only on physical device (landline, mobile phone)
        </Alert>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center',  mt: 1 }}>
          {(state.ringoutId || state.recievingVoicemail) && (
            <>
              <Typography variant="body2" sx={{ mr: 2 }}>
                {state.recievingVoicemail ? "Recieving..." : "Call in progress..."}
              </Typography>
              {state.recievingVoicemail ? (
                <CircularProgress
                  size={20}
                  sx={{ mr: 1, ...style.recievingLoader }}
                />
              ) : (
                <img alt="Calling" src="/assets/calling.gif" />
              )}
            </>
          )}
          <Button
            disabled={
              !!state.phoneNumberError ||
              !state.isPhoneNumberParsed ||
              !(state.phoneNumber) ||
              state.recievingVoicemail
            }
            variant="contained"
            startIcon={
              <img src="/assets/call.svg" alt="svg" width={18} height={18} />
            }
            onClick={() =>
              state.ringoutId
                ? cancelCall()
                : makeRingoutCall(state.phoneNumber)
            }
            sx={{
              mt: 2,
              ...(state.ringoutId ? style.cancelCall : {}),
            }}
          >
            {state.ringoutId ? "Cancel" : "Call Now"}
          </Button>
        </Box>
        {(state.ringoutId || state.recievingVoicemail) && (
          <Alert sx={{ mt: 2 }} severity="warning">
            Please do not press back, reload or close the page until recording is complete.
          </Alert>
        )}
      </Box>
    </Box>
		)
};

export default CallToRecord;